import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { MEDIA_QUERY } from '@zola/zola-ui/src/styles/emotion';
import { WeddingDateDisplayFormatEnum } from '../../../../../../util/websiteDateUtil';
import {
  RangeStartDate,
  RangeEndDate,
  To,
  CustomDateMessage,
} from '../WeddingDateVariants/WeddingDateVerticalSingle/WeddingDateVerticalSingle.styles';

const getDateLocationMixinOverride = (
  locationTop?: number,
  locationTopMobile?: number,
  dateTop?: number,
  dateTopMobile?: number
) => {
  return css`
    .location {
      ${locationTopMobile && `top: ${locationTopMobile}px !important;`}
      ${MEDIA_QUERY.EXCLUDE_MOBILE} {
        ${locationTop && `top: ${locationTop}px !important;`}
      }
    }
    .date {
      ${dateTopMobile && `top: ${dateTopMobile}px !important;`}
      ${MEDIA_QUERY.EXCLUDE_MOBILE} {
        ${dateTop && `top: ${dateTop}px !important;`}
      }
    }
  `;
};

const tahoeRangeStyles = css`
  .content {
    height: 250px;
  }
  .date-wrapper {
    height: 64px;

    &:after {
      content: '';
      position: absolute;
      border-bottom: 1px solid #f0e2ef;
      width: 100%;
      bottom: -20px;
    }

    .date {
      z-index: 3;
    }
    ${RangeStartDate} {
      top: 0px;
      position: absolute;
      width: 100%;
    }
    ${To} {
      position: absolute;
      top: 24px;
    }
    ${RangeEndDate} {
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }
  .hashtag {
    top: 140px !important;
  }
  .location {
    top: 180px !important;
  }
`;

type ThemeSpecificOverrideProps = {
  themeGroup?: string; // truncated theme group name; 'arthur-white' => 'arthur'
  displayFormat?: WeddingDateDisplayFormatEnum;
};

export const WeddingInfoSectionContainer = styled.div<ThemeSpecificOverrideProps>`
  ${({ themeGroup, displayFormat }) => {
    if (themeGroup) {
      switch (themeGroup) {
        case 'august':
          if (displayFormat === WeddingDateDisplayFormatEnum.RANGE) {
            return `height: 400px !important;`;
          }
          break;
        case 'bedford':
          if (displayFormat === WeddingDateDisplayFormatEnum.RANGE) {
            return `height: 485px !important`;
          }
          break;
        case 'tahoe':
          if (displayFormat === WeddingDateDisplayFormatEnum.RANGE) {
            return tahoeRangeStyles;
          }
          if (displayFormat === WeddingDateDisplayFormatEnum.CUSTOM) {
            return css`
              .date-wrapper:before {
                border: none !important;
              }
              ${CustomDateMessage} {
                top: 0 !important;
              }
            `;
          }
          break;
        case 'lachlan':
          if (displayFormat === WeddingDateDisplayFormatEnum.RANGE) {
            return css`
              .vertical-single .date-wrapper {
                padding-top: 116px;
                .date {
                  display: flex !important;
                  .numeric,
                  .day {
                    &::after {
                      content: '.';
                    }
                  }
                }
              }
            `;
          }
          break;
        default:
          return '';
      }
    }
    return '';
  }}
`;

export const HorizontalContainer = styled.div<ThemeSpecificOverrideProps>`
  ${({ themeGroup, displayFormat }) => {
    if (themeGroup && displayFormat === WeddingDateDisplayFormatEnum.RANGE) {
      switch (themeGroup) {
        case 'arthur':
          return getDateLocationMixinOverride(200, 150);
        case 'bow':
          return getDateLocationMixinOverride(300, 150);
        case 'clemson':
          return css`
            .location {
              top: 75% !important;
            }
            .date {
              top: 70% !important;
            }
          `;
        case 'deepcreek':
          return getDateLocationMixinOverride(190, 150);
        case 'larimer':
          return getDateLocationMixinOverride(200, 170);
        case 'lyons':
          return getDateLocationMixinOverride(210, 180);
        case 'rosemont':
          return getDateLocationMixinOverride(230, 180);
        case 'violin':
          return getDateLocationMixinOverride(240, 150);
        case 'tillage':
          return css`
            ${MEDIA_QUERY.MOBILE} {
              .content {
                &:before {
                  top: -30px !important;
                }
                .location {
                  top: 120px !important;
                }
              }
              .hashtag {
                top: 25% !important;
              }
            }
          `;
        default:
          return '';
      }
    }
    return '';
  }}
`;
